/**
 * Shared constants and utilities for cart operations
 * Used by both server-side helpers and client-side components
 */
import { shopifyProductField } from '@/core/contentfulConfig';
import type { SerializedCartItem } from '@/hooks/usePlayGeniusCheckout/utils/cartHelpers';

/**
 * Contentful select fields for product queries
 */
export const PRODUCT_SELECT_FIELDS = [
  'fields.cartTranslations',
  'fields.entryName',
  `fields.${shopifyProductField()}`,
  'fields.variantImageSets',
  'fields.title',
  'fields.backOrderMessage',
  'fields.outOfStockMessage',
  'fields.ageRange',
].join(',');

export const PRODUCT_PAGE_SELECT_FIELDS = [
  'fields.slug',
  'fields.product',
].join(',');

/**
 * Calculates total quantity from serialized cart items, including addon quantities
 * @param items - Array of serialized cart items
 * @returns Total quantity including all addons
 */
export const calculateTotalQuantityWithAddons = (
  items: SerializedCartItem[],
): number => {
  return items.reduce((total, item) => {
    const itemQuantity = item.quantity;
    const addonsQuantity = item.addons.reduce(
      (addonTotal, addon) => addonTotal + addon.quantity,
      0,
    );
    return total + itemQuantity + addonsQuantity;
  }, 0);
};
